<script>
  import { onMount } from "svelte";
  import BPMNModeler from "bpmn-js/lib/Modeler.js";

  import { Accordion, SectionWrapper, Button } from "paxray-components-svelte";
  import Header from "lib/components/Header.svelte";
  import { layoutProcess } from "bpmn-auto-layout";
  import { Loading } from "carbon-components-svelte";
  import { useNavigate } from "svelte-navigator";
  import { ROUTES } from "@utils/routes.js";

  import ProcessSelection from "./components/processSelection.svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import { FULLSCREEN_ICON, ARROW_LEFT_ICON, DOWNLOAD_ICON } from "@utils/icons.js";

  export let analysisid;

  const navigate = useNavigate();

  let viewdiv;
  let modeler;
  let fullscreen = false;
  function toggleFullscreen() {
    fullscreen = !fullscreen;
  }

  let processes = [];

  let selectedClusters = [];

  function automationTraces() {
    fetchWithSession(`/api/analysis/automationTraces/` + analysisid)
      .then((response) => response.json())
      .then((data) => {
        processes = data;
        if (selectedClusters.length == 0 && processes.length > 0)
          selectedClusters = [processes[0].id];
      });
  }

  onMount(() => {
    automationTraces();
    modeler = new BPMNModeler({
      container: bpmn_modeler_container,
      keyboard: {
        bindTo: window,
      },
    });

    modeler.importXML(
      `<?xml version="1.0" encoding="UTF-8"?> <bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" id="Definitions_1is13ea" targetNamespace="http://bpmn.io/schema/bpmn" exporter="bpmn-js (https://demo.bpmn.io)" exporterVersion="10.2.0"> <bpmn:process id="Process_1d2ydle" isExecutable="false"  name=""/> <bpmndi:BPMNDiagram id="BPMNDiagram_1"><bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1d2ydle" /></bpmndi:BPMNDiagram> </bpmn:definitions>`,
    );
  });

  let loading;
  let noise = 10;

  function generateProcessModel(id) {
    loading = true;
    fetchWithSession(
      `/api/analysis/generateDAMProcessModel/${analysisid}/${id}?noise=${noise}`,
    )
      .then((response) => (response.status == 200 ? response.text() : ""))
      .then((data) => {
        layoutProcess(data).then((diagramXML) => {
          modeler.importXML(diagramXML);
          loading = false;
        });
      })
      .catch((err) => {
        console.log(err);
        loading = false;
      });
  }

  $: {
    if (selectedClusters && selectedClusters[0])
      generateProcessModel(selectedClusters[0]);
  }
</script>

<Header section="Workflow Analysis" breadcrumb="BPMN Exporter">
  <Button
    disabled={true}
    iconLeft={true}
    kind="secondary"
    icon={DOWNLOAD_ICON}
    text="BPMN"
  />
  <Button
    kind="secondary"
    text="To Dashboard"
    on:click={() => {
      navigate(`${ROUTES.analysis.dashboard}?analysisid=${analysisid}`);
    }}
    iconLeft={true}
    icon={ARROW_LEFT_ICON}
  />

  <!-- <div class="button_wrapper">
    <Button
      kind="secondary"
      iconRight={true}
      icon={CLOCK_ICON}
      text="KPI"
    />
    <Button
      kind="secondary"
      iconRight={true}
      icon={CLOCK_ICON}
      text="Type"
    />
  </div>
  <div class="kpi_wrapper">
    <SmallKpi value={42} kpi="Time" />
    <SmallKpi value={42} kpi="Users" />
  </div> -->
</Header>

<SectionWrapper {fullscreen}>
  <div class="main_wrapper" slot="main">
    <div class="menu_overlay top"></div>
    <div class="canvas">
      {#if loading}
        <div style="position:absolute; z-index:2">
          <Loading withOverlay={false} />
        </div>
      {/if}
      <div class="bpmn_modeler" id="bpmn_modeler_container">
        <div bind:this={viewdiv} />
      </div>
    </div>
    <div class="menu_overlay bottom">
      <div class="button_wrapper">
        <!-- <ButtonPlusMinus text="Level" value={0} /> -->
      </div>
      <div class="button_wrapper">
        <Button icon={FULLSCREEN_ICON} on:click={toggleFullscreen} />
      </div>
    </div>
  </div>
  <div class="menu" slot="menu">
    <Accordion heading="Process Selection" open={true}>
      <ProcessSelection {processes} bind:selectedProcesses={selectedClusters} />
    </Accordion>

    <!-- @Adrian außer Process selection hab ihc erstmal alles ausgeblendet -->

    <!-- <Accordion heading="Select Variants" open={false}>asdf</Accordion> -->
    <!-- <Accordion heading="Applications" open={false}>
      <div class="flex_wrapper">
        <div class="button_wrapper">
          <SingleSelectNew name="Most Common" placeholder="Application" />
          <SearchNew placeholder="Application" flexGrow={true} />
        </div>
        <div class="applications_wrapper">
          {#each applications as application}
            <SideKpi
              name={application.name}
              value="{application.interactions}%"
            />
          {/each}
        </div>
        <div class="pagination_wrapper">
          <AccordionPagination item="Applications" />
        </div>
      </div>
    </Accordion> -->
    <!-- <Accordion heading="Activities" open={false}>
      <AddToActivity />
    </Accordion> -->
    <!-- <Accordion heading="Information" open={false}>
      <div class="app_information_wrapper">
        <SideKpi name="Time" value={42} />
        <SideKpi name="Interactions" value={42} />
        <SideKpi name="Number of Variants" value={42} />
        <SideKpi name="Unique Events" value={42} />
        <SideKpi name="AVG Time" value={42} />
        <SideKpi
          name="Keyboard Inputs"
          value={42}
          showIcon={true}
          icon="keyboard_dark"
        />
        <SideKpi
          name="Mouse Inputs"
          value={42}
          showIcon={true}
          icon="mouse_dark"
        />
        <SideKpi name="Copy" value={42} showIcon={true} icon="copy_dark" />
        <SideKpi name="Paste" value={42} showIcon={true} icon="paste_dark" />
      </div>
    </Accordion> -->
  </div>
</SectionWrapper>

<style>
  .bpmn_modeler {
    display: flex;
    width: 100%;
    flex-direction: column;
    height: 100% !important;
  }

  #bpmn_modeler_container {
    border-bottom: 1px solid #d9d9d9;
  }

  .button_wrapper {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  .menu {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .main_wrapper {
    position: relative;
    height: 100%;
    width: 100%;
    min-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .menu_overlay {
    position: absolute;
    width: 100%;
    z-index: 1; /* Stellt sicher, dass das Overlay über dem Canvas liegt */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .top {
    top: 0;
    align-items: flex-start;
  }

  .bottom {
    bottom: 0;
  }

  .canvas {
    height: 100%;
    width: 100%;
    z-index: 0; /* Platziert das Canvas hinter den Overlays */
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
